import { render, staticRenderFns } from "./assetFund.vue?vue&type=template&id=5d4aa964"
import script from "./assetFund.vue?vue&type=script&lang=js"
export * from "./assetFund.vue?vue&type=script&lang=js"
import style0 from "./assetFund.vue?vue&type=style&index=0&id=5d4aa964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports